(function($) {

var pageId = 'page-team-settings',
    page = '#' + pageId;

$(function() {
    $(document).on('click', page + ' .team-name a.edit', function(e) {
        e.preventDefault();

        var name = $(this).parents('.page-title').hide().find('.name').text(),
            form = $('form.form-team').show();

        form.find('input').val(name).focus();
    })
    .on('ajax:success', page + ' .form-team', function(e, result) {
        var form = $(this),
            name = result.name;

        form.find('input').val('').end().hide()
            .siblings('.page-title').find('.name').text(name)
            .end().show();
        $('tr-header-team-menu .team-name').text(name);
    })
    .on('click', page + ' .team-name .btn-cancel', function(e) {
        $(this).parents('form:first').hide()
            .find('input').val('')
            .end().siblings('.page-title').show();
    })
    .on('click', page + ' #btn-del-team', function(e) {
        e.preventDefault();
        simple.dialog({
            content: $('#tpl-del-team').html(),
            width: 620,
            modal: true,
            buttons: null
        });
    })
    .on('click', '.form-del-team-confirm .btn-cancel', function() {
        simple.dialog.removeAll()
    })
    .on('ajax:beforeSend', '.form-del-team-confirm', function() {
        var $input = $(this).find('input');
        var dialog = $(this).closest('.simple-dialog').data('dialog');
        if (dialog) {
            dialog.el.hide()
        }
        simple.loading({
            type: 'global',
            msg: '正在删除团队...'
        });
    })
    .on('ajax:success', '.form-del-team-confirm', function(e, result) {
        simple.dialog.removeAll()
        simple.loading.destroy();

        if (result.success) {
            location.href = result.target_url;
        } else {
            $('#btn-del-team').trigger('click');
            $('#del-team-password').addClass('error')
                .parent()
                .after('<p class="error">密码错误</p>');
        }
    })
    .on('ajax:beforeSend', page + ' .form-trans-account', function(e) {
        var btn = $('button[type=submit]', this);
        simple.loading({
            type: "tiny",
            el: btn
        });
    })
    .on('ajax:success', page + ' .form-trans-account', function(e, result) {
        if (result.success) {
            location.href = result.next_url;
        }
    })
    .on('ajax:complete', page + ' .form-trans-account', function(e, result) {
        var btn = $('button[type=submit]', this);
        btn.data('loading').destroy();
    })
    .on('ajax:success', page + ' #export-cancel', function(e, result) {
        tower.stack.load(location.href, {
            nocache: true
        });
    });
});

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    // 初始化选人
    var $form = $('.form-trans-account');
    var $select = $form.find('#assign-admin');
    var select = simple.select({
        el: $select,
        cls: 'select-choose-admins'
    });

    $.ajax({
        url: "/members/" + tower.me.guid + "/admins.json",
        type: 'get',
        dateType: 'json',
        success: function(result) {
            if (!result.length) {
                $form.remove();
                return;
            }

            var adminGuid = $select.data('admin');
            var items = [];
            var selectedItem = null;
            $.each(result, function(i, admin) {
                var item;
                item = {
                    label: admin.nickname,
                    guid: admin.guid,
                    key: admin.nickname + " " + admin.nickname_pinyin + " " + admin.nickname_pinyin_abbr
                };
                if (i === 0) {
                    selectedItem = item;
                    $('input.auid').val(item.guid);
                }
                items.push(item);
            });
            $select.removeClass('loading');
            select.setItems(items);
            select.selectItem($.inArray(selectedItem, items));

            select.on('select', function(e, item) {
                $('input.auid').val(item.guid);
            });

            select.on('clear', function(e) {
                $('input.auid').val("");
            })
        }
    });
});

})(jQuery);
